import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { existingStorage, storage } from './firebase';

/** プロフィール画像URLを取得（dot99 Storage） */
export async function getProfileImageURL(fileName) {
  const fileRef = ref(existingStorage, `profiles/${fileName}`);
  return getDownloadURL(fileRef);
}

/** 完走証画像URLを取得（myrunwallet Storage） */
export async function getCertificateImageURL(certificateId, fileName) {
  const fileRef = ref(storage, `marathon-records/${certificateId}/${fileName}`);
  return getDownloadURL(fileRef);
}

/** サムネイル画像をアップロード（myrunwallet Storage） */
export async function uploadThumbnail(certificateId, dataURL) {
  const res = await fetch(dataURL);
  const blob = await res.blob();
  const fileRef = ref(storage, `marathon-records/${certificateId}/thumbnail.png`);
  await uploadBytesResumable(fileRef, blob, { contentType: 'image/png' });
  return getDownloadURL(fileRef);
}

/** プロフィール画像をアップロード（dot99 Storage） */
export function uploadProfileImage(uid, file, extension) {
  const fileRef = ref(existingStorage, `profiles/${uid}.${extension}`);
  return uploadBytesResumable(fileRef, file);
}

/** プロフィール画像を削除（dot99 Storage） */
export async function deleteProfileImage(fileName) {
  const fileRef = ref(existingStorage, `profiles/${fileName}`);
  await deleteObject(fileRef);
}
